angular.module('forms').factory('FormsService',
    ['FormsId', 'storage',
        function (FormsId, storage) {
            'use strict';

            var completedForm = {
                Form: {Id: '', Name: ''},
                Patient: {Id: ''}
            };

            function timeFrameInputIsVisible(timeFrameId) {
                if (timeFrameId && timeFrameId.toUpperCase() === FormsId.TimeFrameId.DaysAgo) {
                    return true;
                }
                if (timeFrameId && timeFrameId.toUpperCase() === FormsId.TimeFrameId.WeeksAgo) {
                    return true;
                }
                if (timeFrameId && timeFrameId.toUpperCase() === FormsId.TimeFrameId.MonthsAgo) {
                    return true;
                }
                if (timeFrameId && timeFrameId.toUpperCase() === FormsId.TimeFrameId.YearsAgo) {
                    return true;
                }
                return false;
            }

            function calendarInputIsVisible(timeFrameId) {
                if (timeFrameId.toUpperCase() === FormsId.TimeFrameId.Calendar) {
                    return true;
                } else {
                    return false;
                }
            }

            function cacheCompletedForm(cacheForm) {
                completedForm.Form.Id = cacheForm.Form.Id;
                completedForm.Form.Name = cacheForm.Form.Name;
                completedForm.Patient.Id = cacheForm.Patient.Id;
            }

            function clearCompletedForm() {
                completedForm.Form.Id = '';
                completedForm.Form.Name = '';
                completedForm.Patient.Id = '';
            }

            function getCompletedForm() {
                return completedForm;
            }

            function getNewProblemHistoryAnswer(problemHistoryAnswerId, historyGroupId, diseaseId, name) {
                var problemHistoryAnswer = {
                    CameFromPatientChart: false,
                    ProblemHistoryAnswerId: problemHistoryAnswerId,
                    HistoryGroupId: historyGroupId,
                    DiseaseId: diseaseId,
                    DiseaseName: name,
                    Selected: false,
                    CauseOfDeath: false,
                    Denies: false,
                    OnsetTimeFrame: {
                        OnsetTimeFrameId: '',
                        OnsetTimeFrameValue: '',
                        OnsetTimeFrameDate: '',
                        OnsetTimeFrameAnswer: ''
                    }
                };

                return problemHistoryAnswer;
            }

            function getNewFamilyHistoryAnswer() {
                var familyHistoryAnswer = {
                    CameFromPatientChart: false,
                    RelationshipId: '',
                    RelationshipName: '',
                    IsRelationshipMaternal: '',
                    IsRelationshipPaternal: '',
                    IsRelationshipUnknown: '',
                    FirstName: '',
                    LastName: '',
                    BirthDateTimeFrame: {
                        OnsetTimeFrameId: '',
                        OnsetTimeFrameValue: '',
                        OnsetTimeFrameDate: ''
                    },
                    DeathDateTimeFrame: {
                        OnsetTimeFrameId: '',
                        OnsetTimeFrameValue: '',
                        OnsetTimeFrameDate: ''
                    },
                    NoKnownDiseases: false,
                    ProblemHistoryAnswers: []
                };

                return familyHistoryAnswer;
            }

            function getNewImmunizationHistoryAnswer(isAdultCard, isPediatricCard, vaccineCard) {
                var immunizationCard = {
                    IsAdultCard: isAdultCard,
                    IsPediatricCard: isPediatricCard,
                    ImmunizationAnswers: []
                };

                if (vaccineCard) {
                    immunizationCard.VaccineAdminId = vaccineCard.VaccineAdminId;
                    immunizationCard.VaccineAdminName = vaccineCard.Name;
                    immunizationCard.Inactive = vaccineCard.Inactive;

                    if (vaccineCard.PatientImmunizationCardItems) {
                        _.forEach(vaccineCard.PatientImmunizationCardItems, function (vaccineItem) {
                            var item = {
                                VaccineAdminItemId: vaccineItem.VaccineAdminItemId,
                                VaccineId: vaccineItem.VaccineId,
                                VaccineName: vaccineItem.PatientImmunization.Name,
                                VaccineInactive: vaccineItem.PatientImmunization.Inactive,
                                TypeofVaccineId: vaccineItem.TypeofVaccineId,
                                DisplayOrder: vaccineItem.DisplayOrder,
                                Inactive: vaccineItem.Inactive,
                                Selected: false,
                                OnsetTimeFrame: {
                                    OnsetTimeFrameId: '',
                                    OnsetTimeFrameValue: '',
                                    OnsetTimeFrameDate: ''
                                },
                                VaccineAdminIdVaccineAdminItemId: vaccineCard.VaccineAdminId + '_' + vaccineItem.VaccineAdminItemId
                            };
                            immunizationCard.ImmunizationAnswers.push(item);
                        });
                    }
                }

                return immunizationCard;
            }

            function removeLocalStorageKeys(startsWith) {
                if (startsWith.length === 0) {
                    return;
                }

                var len = startsWith.length;
                _.forEach(storage.getKeys(), function(key) {
                    if (key.substring(0, len) === startsWith) {
                        storage.remove(key);
                    }
                });
            }

            return {
                getCompletedForm: getCompletedForm,
                cacheCompletedForm: cacheCompletedForm,
                clearCompletedForm: clearCompletedForm,
                timeFrameInputIsVisible: timeFrameInputIsVisible,
                calendarInputIsVisible: calendarInputIsVisible,
                getNewProblemHistoryAnswer: getNewProblemHistoryAnswer,
                getNewFamilyHistoryAnswer: getNewFamilyHistoryAnswer,
                getNewImmunizationHistoryAnswer: getNewImmunizationHistoryAnswer,
                removeLocalStorageKeys: removeLocalStorageKeys
            };

        }]);